import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import PageTitle from '../../components/PageTitle/PageTitle';
import Loader from '../../components/Loader/LoaderView';
import FormInputLabel from '../../components/FormInputLabelView';
import { Link } from 'react-router-dom';
import {
  Grid,
  withStyles,
  TextField,
  Button,
  Paper,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Checkbox,
  IconButton,
  MenuItem,
  Select,
  Input,
} from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';
import { withTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
import { clearLocalStorage } from '../../utils/common';
import CustomFooter from '../../components/Table/CustomFooter';

class ManageDevicesPermission extends Component {
  constructor() {
    super();
    this.state = {
      loading: false,
      selectDevicesList: [],
      name: '',
      subgroupId: 0,
      tenantId: null,
      subGroupsList: [],
      applyModulesList: [],
      take: 100,
      skip: 0,
    };
  }

  async componentDidMount() {
    const modulePath = this.props.location.pathname.replace('/app/modules/', '');
    const moduleId = Number(modulePath.replace('/manage/device', ''));
    await this.initData(moduleId);
    this.initselectDevicesList(moduleId);
  }

  async initData(moduleId) {
    const subGroup = await this.props.subGroup.getSubgroupById(moduleId);
    if (subGroup) {
      this.setState({
        name: subGroup.name,
        subgroupId: subGroup.id,
        tenantId: subGroup.tenantId,
      });
      await this.props.subGroup.getSubGroupSelect(subGroup.tenantId);

      const { skip, take } = this.state;
      this.props.devicePermission.setData('tenantIds', [subGroup.tenantId], false);
      this.props.devicePermission.setData('limit', take, false);
      this.props.devicePermission.setData('search', null, false);
      this.props.devicePermission.setData('filterOutStatus', ['NEW'], false);
      await this.props.devicePermission.getDevicesForPermission(['NEW'], skip, take);
    }
  }

  async initselectDevicesList(id) {
    let subgroupIds = [];
    subgroupIds.push(id);

    await this.props.device.getDevicesBySubgroupIds(subgroupIds);

    const { devicesList } = this.props.device.toJS();
    let mapDevice = (devicesList || []).map((val) => {
      return {
        id: val.id ? val.id : '',
        label: val.id ? (val.name && val.name.length > 0 ? `${val.name} (${val.serial})` : val.serial) : '',
      };
    });

    this.setState({ selectDevicesList: mapDevice });
  }

  handleToggle(val) {
    let selectDevicesList = this.state.selectDevicesList;
    const checkSelected = selectDevicesList.find((data) => data.id === val.id);

    if (checkSelected) {
      selectDevicesList = selectDevicesList.filter((data) => data.id !== val.id);
    } else {
      selectDevicesList.push(val);
    }
    this.setState({ selectDevicesList });
  }

  handleDelete(val) {
    const selectDevicesList = this.state.selectDevicesList.filter((data) => data.id !== val.id);
    this.setState({ selectDevicesList });
  }

  handleSaveDevices = async () => {
    const { t } = this.props;
    const { selectDevicesList, subgroupId } = this.state;
    const modulesIdList = this.getModuleId();
    modulesIdList.push(subgroupId);
    try {
      const result = await this.props.device.saveDevices(selectDevicesList, modulesIdList);
      if (result.statusCode === 200) {
        Swal.fire({ html: `<h4>${t('assign_success')}`, type: 'success' }).then(async (resultSuccess) => {
          if (resultSuccess.value) {
            const { offset, limit, search, sort, order, action } = this.props.subGroup.toJS();
            await this.props.subGroup.getSubGroup(offset, limit, search, sort, order, action);
            // this.props.history.push('../../../modules');
          }
        });
      } else {
        Swal.fire({ html: `<h4>${t('failed_to_assign')}`, type: 'error' });
      }
    } catch (e) {
      if (e.statusCode === 401) {
        clearLocalStorage();
        window.location.href = '/login';
      } else {
        Swal.fire({ html: `<h4>${t('failed_to_assign')}`, type: 'error' });
      }
    }
  };

  handleChange = async (e) => {
    let { name, value } = e.target;
    this.setState((prevState) => {
      prevState[name] = value;
      return prevState;
    });
    this.initselectDevicesList(value);
  };

  handleSelectSubGroup = (e) => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
    });
  };

  getModuleId = () => {
    const { allSubgroups } = this.props.subGroup.toJS();
    let moduleIdList = [];
    const { subGroupsList } = this.state;
    subGroupsList.forEach((selected) => {
      let module = allSubgroups.find((val) => val.name === selected);
      moduleIdList.push(module.id);
    });

    return moduleIdList;
  };

  handleSearch = async (task, value) => {
    this.props.devicePermission.setData('offset', 0, false);
    // await new Promise((resolve) => setTimeout(resolve, 1000));
    await this.props.devicePermission.setData(task, value);
  };

  handleChangeRowsPerPage = (value) => {
    this.props.devicePermission.setData('limit', value);
  };

  handleChangePage = async (value) => {
    await this.props.devicePermission.setData('offset', value * this.state.take);
  };

  render() {
    const { classes, t } = this.props;
    const { selectDevicesList, subgroupId, subGroupsList } = this.state;
    const device = this.props.devicePermission.toJS();
    const { loading, allSubgroups } = this.props.subGroup.toJS();
    const subGroupsNoSelect = (allSubgroups || []).filter((value) => {
      return value.id !== subgroupId;
    });
    const count = device.devices.data ? device.devices.pagination.count : 0;
    const page = device.devices.data ? device.devices.pagination.page - 1 : 0;
    console.log('subGroupsList: ', subGroupsList);
    return (
      <React.Fragment>
        <Loader loading={device.loading || loading} />
        <Paper className={classes.paper}>
          <PageTitle title={t('assign_devices')} />
          <Grid container spacing={16} className={classes.wrapContain}>
            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('module_name')} />
            </Grid>
            <Grid item xs={12} sm={4}>
              <Paper className={`${classes.root} selectInput ${classes.spaceTop}`}>
                <Select
                  value={subgroupId}
                  onChange={this.handleChange}
                  inputProps={{
                    name: 'subgroupId',
                    id: 'subgroupId',
                  }}
                >
                  {(allSubgroups || []).map((val) => (
                    <MenuItem fullwidth='true' key={val.id} value={val.id}>
                      {`${val.name || 'subgroupId'}`}
                    </MenuItem>
                  ))}
                </Select>
              </Paper>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Paper className={`${classes.root} selectInput ${classes.spaceTop}`}>
                <Select
                  name='subGroupsList'
                  multiple
                  displayEmpty
                  value={subGroupsList || ''}
                  onChange={this.handleSelectSubGroup}
                  input={<Input id='select-multiple' />}
                  renderValue={(selected) => {
                    if (selected.length === 0) {
                      return t('apply_to');
                    }
                    return selected.join(', ');
                  }}
                  inputProps={{
                    name: 'subGroupsList',
                    id: 'subGroupsList',
                  }}
                >
                  <MenuItem disabled fullwidth='true' value=''>
                    {t('apply_to')}
                  </MenuItem>
                  {(subGroupsNoSelect || []).map((data) => (
                    <MenuItem fullwidth='true' key={data.id} value={data.name}>
                      {data.name}
                    </MenuItem>
                  ))}
                </Select>
              </Paper>
            </Grid>
          </Grid>
          <Grid container spacing={16} className={classes.wrapDeviceList}>
            <Grid item xs={6} sm={6}>
              <FormInputLabel label={t('devices_list')} />
            </Grid>
            <Grid item xs={6} sm={6}>
              <FormInputLabel label={t('devices_in_module')} />
            </Grid>
          </Grid>

          <Grid container spacing={16} className={classes.wrapDeviceList}>
            <Grid item xs={6} sm={6}>
              <TextField
                required
                id='search'
                name='search'
                fullWidth
                value={device.search || ''}
                onChange={(e) => this.handleSearch('search', e.target.value)}
                variant='outlined'
                margin='dense'
                placeholder={t('search')}
              />
            </Grid>
            <Grid item xs={6} sm={6} />

            <Grid item xs={6} sm={6}>
              <List
                className={
                  device.devices.data && device.devices.data.length > 0
                    ? classes.muitiSelect
                    : classes.muitiSelectNoBorder
                }
              >
                {(device.devices.data || []).map((val) => {
                  return (
                    <ListItem key={val.id} role={undefined} dense button onClick={() => this.handleToggle(val)}>
                      <ListItemIcon style={{ marginRight: '0px' }}>
                        <Checkbox
                          style={{ padding: '0px' }}
                          color='primary'
                          edge='start'
                          checked={selectDevicesList.find((data) => data.id === val.id) ? true : false}
                          tabIndex={-1}
                          disableRipple
                          inputProps={{
                            'aria-labelledby': `checkbox-list-label-${val.id}`,
                          }}
                        />
                      </ListItemIcon>
                      <ListItemText
                        className={classes.labelCheckBox}
                        id={`checkbox-list-label-${val.id}`}
                        primary={`${val.label}`}
                      />
                    </ListItem>
                  );
                })}
              </List>
              <div style={{ position: 'relative' }}>
                <div style={{ position: 'absolute', right: '-30px' }}>
                  <CustomFooter
                    count={count}
                    page={page}
                    rowsPerPage={this.state.take}
                    rowsPerPageOptions={[]}
                    changeRowsPerPage={this.handleChangeRowsPerPage}
                    changePage={this.handleChangePage}
                  />
                </div>
              </div>
            </Grid>

            <Grid item xs={6} sm={6}>
              <List className={selectDevicesList.length > 0 ? classes.muitiSelect : classes.muitiSelectNoBorder}>
                {selectDevicesList.map((val) => {
                  return (
                    <ListItem key={val.id} role={undefined} dense button onClick={() => this.handleDelete(val)}>
                      <ListItemIcon style={{ marginRight: '0px' }}>
                        <IconButton style={{ padding: '0px' }} edge='end' aria-label='delete'>
                          <ClearIcon />
                        </IconButton>
                      </ListItemIcon>
                      <ListItemText
                        className={classes.labelCheckBox}
                        id={`select-list-label-${val.id}`}
                        primary={`${val.label}`}
                      />
                    </ListItem>
                  );
                })}
              </List>
            </Grid>
          </Grid>

          <Grid item xs={12} sm={12} md={12}>
            <div className={classes.buttons}>
              <Link to='/app/modules'>
                <Button className={classes.button}>{t('back')}</Button>
              </Link>
              <Button
                variant='contained'
                color='primary'
                onClick={() => this.handleSaveDevices()}
                className={classes.button}
              >
                {t('save')}
              </Button>
            </div>
          </Grid>
        </Paper>
      </React.Fragment>
    );
  }
}

const styles = (theme) => ({
  labelCheckBox: {
    paddingLeft: '5px',
    fontSize: '14px',
    [theme.breakpoints.down('sm')]: {
      overflow: 'hidden',
      padding: '0',
      textOverflow: 'ellipsis',
      display: '-webkit-box',
      WebkitLineClamp: '1',
      WebkitBoxOrient: 'vertical',
    },
  },
  paper: {
    padding: '24px',
    margin: '30px',
  },
  wrapContain: {
    padding: '15px 20px 5px 20px',
  },
  wrapDeviceList: {
    padding: '5px 20px',
  },
  buttons: {
    marginTop: '40px',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    marginLeft: '5px',
  },
  muitiSelect: {
    // marginTop: "5px",
    // marginBottom: "35px",
    borderRadius: '5px',
    borderStyle: 'solid',
    borderColor: 'gray',
    borderWidth: '1px',
    // maxHeight: 450,
    position: 'relative',
    overflow: 'auto',
    height: 450,
  },
  boxSelect: {},
  muitiSelectNoBorder: {
    // marginTop: "5px",
    marginBottom: '35px',
  },
  center: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
});

export const page = inject('subGroup', 'device', 'devicePermission')(observer(ManageDevicesPermission));
export const translation = withTranslation()(page);
export default withStyles(styles, { withTheme: true })(translation);
